import { ListViewRowWrapper } from '@ami/react/core';
import Row from './InventoryItemTableRow';
import { InventoryItemViewModel } from '../../inventory-items/inventoryItem';
import PropTypes from 'prop-types';
import React from 'react';
//import './InventoryItemTable.scss';

const InventoryItemTable = ({
  inventoryItems,
  onOpenEdit,
  loading,
  onBottomScroll,
}) => {
  const rows = inventoryItems.map((inventoryItem) => (
    <Row
      inventoryItem={inventoryItem}
      key={inventoryItem.id}
      onOpenEdit={onOpenEdit}
    />
  ));
  return (
    <table className="table table-striped table-hover table-mobile">
      <thead>
        <tr>
          <th width="10%"></th>
          <th width="20%">Name</th>
          <th width="30%">Compatibility</th>
          <th width="15%">Part Number</th>
          <th width="10%">Condition</th>
          <th width="8%">Availability</th>
          <th width="7%">Quantity</th>
        </tr>
      </thead>
      <tbody>
        <ListViewRowWrapper
          rows={rows}
          numberOfColumns={7}
          loading={loading}
          onBottomScroll={onBottomScroll}
        />
      </tbody>
    </table>
  );
};

InventoryItemTable.propTypes = {
  inventoryItems: PropTypes.arrayOf(
    PropTypes.instanceOf(InventoryItemViewModel)
  ).isRequired,
  onOpenEdit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  onBottomScroll: PropTypes.func,
};

export { InventoryItemTable };
